import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import { message } from "antd";

class FuelFilledReportStore {
  loading=false
  fuelFilledReport = []
  getDrivers=[]
  rootStore
  last_record_timestamp = ""
  pythonReportMessage = false
  pythonReportErrorMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      fuelFilledReport: observable,
      loadData: action,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage:observable

    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId,vehicleId,offset, limit,driverId,fromDate,toDate,pageNo }) {
    this.loading=true
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset,"limit":limit, "page":pageNo }
    
    if (offset === 0) {
      postData.last_record_timestamp = ""
    } else {
      postData.last_record_timestamp = this.last_record_timestamp
    }

    var response = await postApi.getClient('report').post("/fleet_report/fuelFilledReport", postData);

    this.last_record_timestamp = response?.data?.data?.last_record_timestamp
    this.fuelFilledReport = response?.data?.data?.fuelfillrep
    this.total = response?.data?.data?.TotalCount
    this.loading=false
  }

  async getDriversByCompanyId({companyId}){
    var postData = {companyId:companyId}
    var response = await postApi.getClient().get("/driver/getDriverList", {params: postData});
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi.getClient().post("index.php?c=driver&a=getdatabycompany", "postData=" + base64Input);
    // console.log(response, "post")
    this.getDrivers =response?.data?.drivers
    return response?.data?.drivers
  }

  

  async exportExcel(getData) {
    
      getData = { ...getData, language: "english" }
    
      try {

        await postApi.getClient().post("/fleet_report/fuelFilledReport/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

  }

  async exportpdf(getData) {
    getData = { ...getData, language: "english" }
    try {

      await postApi.getClient("report").post("/fleet_report/fuelFilledReport/download/pdf", getData, {
        responseType: "blob",
      });

      this.pythonReportMessage = true;

    } catch (error) {
      this.pythonReportErrorMessage = false;
      message.error("Failed to download the report. Please try again.")
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportfuelrepcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&did="+
      getData.DriverId+
      "&fD=" +
      getData.fromDate +
     
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportfuelrepxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&did="+
      getData.DriverId+
      "&fD=" +
      getData.fromDate +
     
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default FuelFilledReportStore;
